export const pushSupported = () => typeof window !== "undefined" && "Notification" in window;

export const pushPermission = () => (pushSupported() ? Notification.permission : "unsupported");

export async function enablePush() {
  if (!pushSupported()) return "unsupported";
  try {
    return await Notification.requestPermission();
  } catch {
    return "denied";
  }
}

export function showSystemAlert(title, body, link) {
  if (pushPermission() !== "granted") return;
  try {
    const n = new Notification(title, { body, icon: "/logo.jpg", tag: link || title });
    n.onclick = () => { window.focus(); if (link) window.location.assign(link); };
  } catch {}
}
